import { observer } from 'mobx-react';
import * as React from 'react';
import { ResourceAutoCompleteViewModelType } from '../../../../../extViewmodels';
import { LeadRuleViewModel } from '../../../../viewModels/leadrules';
import { SelectionPicker } from './SelectionPicker';

interface IProps {
	leadRule: LeadRuleViewModel;
}

export const VerticalPicker: React.FC<IProps> = observer(({ leadRule }) => (
	<SelectionPicker<string>
		items={(leadRule?.verticals ?? []).map(name => ({ id: name, name }))}
		onAdd={selection => leadRule?.setVerticals(leadRule?.verticals?.concat(selection))}
		onRemove={id => leadRule?.setVerticals(leadRule?.verticals.filter(item => item !== id))}
		placeholder='Search Lead Pool'
		type={ResourceAutoCompleteViewModelType.Vertical}
	/>
));
